import {Component, Input, OnInit} from '@angular/core';
import {AppService} from '../../../services/app.service';
import * as $ from 'jquery';
import {User} from '../../../_models/user.model';

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.css']
})
export class WishlistComponent implements OnInit {

  product: any;
  accessToken = '';
  currentUser: User;

  constructor(private appService: AppService) {
  }

  @Input()
  get productData(): string {
    return this.product;
  }

  set productData(product: any) {
    this.product = product;
  }

  ngOnInit(): void {

    this.accessToken = this.appService.getAccessToken();
    setTimeout(() => {                           // <<<---using ()=> syntax
      $('.fa-bookmark, .fa-bookmark-o').removeClass('ng-star-inserted');
    }, 500);

  }

  addToWishlist(e): void {

    let w = $(e).attr('class');
    (w === 'fa fa-bookmark-o') ? $(e).attr('class', 'fa fa-bookmark') : $(e).attr('class', 'fa fa-bookmark-o');
    if (w === 'fa fa-bookmark-o') {
      // add to wishlist
      this.appService.addToWishlist(this.product.details.id);
    } else {
      // remove from wishlist
      this.appService.removeFromWishlist(this.product.details.id);
    }
  }
}
